// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"302":"swiggy_mxn_render","335":"lottie-web","540":"mro_and_aip","570":"dine_cash_pooling"}[chunkId] + "." + {"302":"7b06e6075c44740ad91f","335":"c8d48889b30084413518","540":"77fff70d019b97c1df4c","570":"c15a1785f6ad92aa87e9"}[chunkId] + ".js";
};